import { render, staticRenderFns } from "./ZUserInfo.vue?vue&type=template&id=2d14f1a2&scoped=true&"
import script from "./ZUserInfo.vue?vue&type=script&lang=js&"
export * from "./ZUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./ZUserInfo.vue?vue&type=style&index=0&id=2d14f1a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d14f1a2",
  null
  
)

export default component.exports